module.exports = __webpack_public_path__ + "static/img/f89ffe3374a8b4ede2bb46b212407c3.d15e43b5.png";